export var ContextGLStencilAction;
(function (ContextGLStencilAction) {
    ContextGLStencilAction[ContextGLStencilAction["DECREMENT_SATURATE"] = 0] = "DECREMENT_SATURATE";
    ContextGLStencilAction[ContextGLStencilAction["DECREMENT_WRAP"] = 1] = "DECREMENT_WRAP";
    ContextGLStencilAction[ContextGLStencilAction["INCREMENT_SATURATE"] = 2] = "INCREMENT_SATURATE";
    ContextGLStencilAction[ContextGLStencilAction["INCREMENT_WRAP"] = 3] = "INCREMENT_WRAP";
    ContextGLStencilAction[ContextGLStencilAction["INVERT"] = 4] = "INVERT";
    ContextGLStencilAction[ContextGLStencilAction["KEEP"] = 5] = "KEEP";
    ContextGLStencilAction[ContextGLStencilAction["SET"] = 6] = "SET";
    ContextGLStencilAction[ContextGLStencilAction["ZERO"] = 7] = "ZERO";
})(ContextGLStencilAction || (ContextGLStencilAction = {}));
